// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__1B5zW","spinner":"Spinner_spinner__qdUya"};